import { darken, styled } from "@mui/material/styles";

// Components
import { MenuItem } from "@mui/material";

// Themes
import { theme } from "~/components/Common";

const styledName = "WalletOptions";

export const StyledDeleteButton = styled(MenuItem, { name: styledName })({
  "&": {
    color: theme.palette.error.light,
    ":hover": {
      color: darken(theme.palette.error.light, 0.1),
      backgroundColor: "transparent",
    },
  },
});
